module.exports = __webpack_public_path__ + "static/media/responsiveweb.7b1e32a2.svg";